module.exports = '4.8.2';



// WEBPACK FOOTER //
// ./src/version.js